<template>
  <div class="dashboard_table page-wrapper">
    <search-list @searchParams="search"></search-list>
    <div class="cards mt20">

      <Row :gutter="12" class="cards">
        <Col v-for="(item,i) in cards" style="min-width:260px" :key="'keyA'+i" span="12" :md="8" :lg="6">
          <card class="card" :data="item" :key="'keyA'+i"></card>
        </Col>
      </Row>
    </div>
    <h2 class="mt20">收支对比</h2>
    <div style="background:#f8f8f9">
<!--      <Table ref="table" class="mt12" :columns="columns" :row-class-name="rowClassName"-->
<!--             :data="tableData"-->

<!--             :loading="loading"></Table>-->

      <el-table border row-key="type" :expand-row-keys="expands" :data="tableData" style="width: 100%;" size="small" :indent=2 v-loading="loading">

        <el-table-column prop="type" label="类型" width="150" fixed="left">
          <template slot-scope="scope">
            <span style="flex: auto">{{scope.row.type}}</span>
            <el-tooltip v-if="scope.row.tips" class="item" effect="dark" :content="scope.row.tips" placement="right"
                        style="float: right;">
              <img :src="icon" alt="" style="width: 16px;cursor: pointer;vertical-align: middle;">
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="expect" label="预想占比" width="120" >

        </el-table-column> -->

        <el-table-column width="130" :label="item.title" v-for="(item,index) in columnsEle" :key="index" :prop="item.money.key">
          <!-- <el-table-column width="130" label="金额"  > -->
            <template slot-scope="scope">
              <span style="flex: auto">{{formatMoneyInt(scope.row[item.money.key])+''||'暂未取到数据'}}</span>
              <el-tooltip v-if="scope.row[item.money.tips]&&scope.row[item.money.tips].length" class="item" effect="dark" :content="scope.row[item.money.tips].join(';')" placement="top"
                          style="float: right;">
                <img :src="icon" alt="" style="width: 16px;cursor: pointer;vertical-align: middle;">
              </el-tooltip>
            </template>
          <!-- </el-table-column> -->
          <!-- <el-table-column width="120" label="占比" :prop="item.percent.key">
            <template slot-scope="scope">
              <span :style="{color:computedColor(parseFloat(scope.row[item.percent.key]), parseFloat(scope.row['expect']), scope.row['isSignRed'])}">{{scope.row[item.percent.key]}}</span>
            </template>
          </el-table-column> -->
        </el-table-column>
      </el-table>
    </div>
    <line-chart :titleText="' '"
                :source="source"
                :option="option"
                :height="'380px'"
                v-if="false"
    ></line-chart>

  </div>
</template>

<script>
  import SearchList from './components/SearchList'
  import LineChart from '@/components/Chart/index'
  import Card from './components/Cards'
  import {incomeAndCostlist, profitGraphlist, managementcards} from "../../../api/incomemanage";
  import subTable from './components/SubTable';
  import {formatMoneyInt} from '@/utils/format';
  import icon from '../../../assets/icon_info@2x.png'

  import {Table, TableColumn, Tooltip,Loading} from 'element-ui'
  import 'element-ui/lib/theme-chalk/index.css';
  import Vue from 'vue'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Tooltip)
  Vue.use(Loading)


  export default {
    name: "incomeboard",
    components: {
      SearchList,
      LineChart,
      Card,

    },
    methods: {
      resetHeight() {
        this.$refs['table'] && this.$refs['table'].handleResize()


      },

      handleChartData(data) {
        const source = [["time", "GOP", "毛利", "净利",]];
        data.forEach(item => {
          source.push([item.dataTime, (item.gopData).toFixed(0), (item.grossData).toFixed(0), (item.profitData).toFixed(0)]);
        });
        return source;
      },

      search(params) {
        this.loading = true
        this.list = []
        this.source = []

        incomeAndCostlist(params).then(res => {
          if (!res.data) {
            return
          }
          this.list = res.data;

        }).catch(error => {

        }).finally(() => {
          this.loading = false
        })

        profitGraphlist(params).then(res => {
          if (!res.data) {
            return

          }
          this.source = this.handleChartData(res.data)


        }).catch(error => {
        })

        managementcards(params).then(res => {
          if (!res.data) {
            this.cards = []
            return

          }
          this.cards = res.data

        }).catch(error => {
        })


      },

      rowClassName(row, index) {
        return 'c-table-gray';
      },

      computedColor(percent, expect, isSignRed) {
        if (isNaN(percent) || !expect) {
          return 'inherit';
        }
        if (percent == -1 || percent == expect) {
          return 'inherit';
        }
        if (isSignRed === 1) {
          return percent > expect ? 'red' : 'inherit'

        }
        if (isSignRed === 0) {
          return percent < expect ? 'red' : 'inherit'
        }
        return 'inherit'
        //
        // if (percent < expect) {
        //   return 'red';
        // } else {
        //   return 'inherit';
        // }
      },
    },
    computed: {
      columnsEle() {
        const ret = []
        if (this.list.length) {
          this.list[0].voList && this.list[0].voList.forEach((ele, index) => {
            ret.push({
              title: ele.projectName,
                money:{
                  title: '金额',
                  key: 'money' + index,
                  tips:'tips'+index
                },
                // percent:{
                //   title: '占比',
                //   key: 'percent' + index,

                // }
            })
          })

        }
        return ret


      },
      // columns() {
      //   let ret = [
      //     {
      //       width: 50,
      //       type: 'expand',
      //       title: ' ',
      //       render: (h, params) => {
      //
      //         return h(subTable, {
      //           props: {
      //             columns: this.columns,
      //             data: params.row['children']
      //           }
      //
      //         })
      //       }
      //     },
      //     {
      //       title: '类型',
      //       align: 'center',
      //       key: 'type',
      //       width: 140,
      //       fixed: 'left',
      //       render: (h, params) => {
      //         let toolTip = h('Tooltip', {
      //           props: {
      //             placement: "top"
      //           },
      //           style: {
      //             flex: 'none',
      //             width: '20px'
      //
      //           }
      //
      //         }, [
      //           h('div', {
      //             style: {
      //               whiteSpace: 'normal'
      //             },
      //             slot: 'content',
      //           }, params.row['tips']),
      //           h('img', {
      //             style: {
      //               width: '16px',
      //               verticalAlign: "middle",
      //               cursor: 'grab'
      //
      //             },
      //             attrs: {
      //               src: icon
      //             }
      //           }, '')
      //
      //
      //         ])
      //         return h('div', {
      //           style: {
      //             display: 'flex',
      //             alignItems: 'center'
      //           }
      //
      //         }, [
      //           h('span', {
      //             style: {
      //               flex: 'auto',
      //               width: '50px'
      //             }
      //           }, params.row['type']), params.row['tips'] ? toolTip : ''
      //         ])
      //       }
      //     },
      //     {
      //       title: '预想占比',
      //       align: 'center',
      //       key: 'expect',
      //       width: 120,
      //     },
      //   ]
      //
      //   if (this.list.length) {
      //     this.list[0].voList && this.list[0].voList.forEach((ele, index) => {
      //       ret.push({
      //         title: ele.projectName,
      //         align: 'center',
      //         children: [
      //           {
      //             title: '金额',
      //             align: 'center',
      //             key: 'money' + index,
      //             width: this.list[0].voList.length > 2 ? 120 : 200,
      //             render: (h, params) => {
      //               let toolTip = h('Tooltip', {
      //                 props: {
      //                   placement: "top"
      //                 },
      //                 style: {
      //                   flex: 'none',
      //                   width: '20px'
      //
      //                 }
      //
      //               }, [
      //                 h('div', {
      //                   style: {
      //                     whiteSpace: 'normal'
      //                   },
      //                   domProps: {
      //                     innerHTML: (params.row['tips' + index] && params.row['tips' + index].length) ? params.row['tips' + index].join('<br/>') : ''
      //
      //                   },
      //                   directives: [
      //                     // {
      //                     //   name: 'v-html',
      //                     //
      //                     // }
      //                   ],
      //                   slot: 'content',
      //                 }, ''),
      //                 h('img', {
      //                   style: {
      //                     width: '16px',
      //                     verticalAlign: "middle",
      //                     cursor: 'grab'
      //
      //                   },
      //                   attrs: {
      //                     src: icon
      //                   }
      //                 }, '')
      //
      //
      //               ])
      //               return h('div', {
      //                 style: {
      //                   display: 'flex',
      //                   alignItems: 'center'
      //                 }
      //               }, [
      //                 h('span', {
      //                   style: {
      //                     flex: 'auto',
      //                     // width:'50px'
      //                   }
      //
      //                 }, formatMoneyInt(params.row['money' + index], '暂未取到数据')),
      //                 (params.row['tips' + index] && params.row['tips' + index].length) ? toolTip : ''
      //
      //
      //               ])
      //               // return h('span', {},formatMoneyInt(params.row['money' + index],'暂未取到数据'));
      //             },
      //
      //           },
      //           {
      //             title: '占比',
      //             align: 'center',
      //             key: 'percent' + index,
      //             width: this.list[0].voList.length > 2 ? 120 : 200,
      //             render: (h, params) => {
      //               return h('span', {
      //                 style: {
      //                   color: this.computedColor(parseFloat(params.row['percent' + index]), parseFloat(params.row['expect']), params.row['isSignRed']),
      //
      //                 }
      //               }, params.row['percent' + index])
      //             }
      //           },
      //         ]
      //       })
      //     })
      //
      //   }
      //   return ret
      // },
      tableData() {
        if (!this.list.length) {
          return []
        }
        let data = []

        function makeData(arr) {
          const ret = []
          arr.forEach(ele => {
            const item = {}
            item['type'] = ele.type
            item['expect'] = ele.expect
            item['tips'] = ele.tips
            item['isSignRed'] = ele.isSignRed
            ele.voList && ele.voList.forEach((ele1, index1) => {
              item['money' + index1] = ele1.money
              item['percent' + index1] = ele1.percent
              item['money' + index1] = ele1.money
              item['tips' + index1] = ele1.tips
            })

            if (ele.children && ele.children.length) {
              item['children'] = makeData(ele.children)
            } else {
              item['_disableExpand'] = true
            }
            ret.push(item)
          })
          return ret
        }

        data = makeData(this.list)
        console.log(data,'data')
        return data

      }


    },
    data() {
      return {
        expands:['收入','成本'],
        formatMoneyInt:formatMoneyInt,
        icon: icon,
        list: [],
        loading: false,
        cards: [],
        source: [],
        option: {
          grid: {left: 120, right: 50, top: 50, bottom: 60},
          yAxis: {
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            min: 'dataMin',
            axisLabel: {
              // formatter: function (value) {
              //   return value*100
              // }
            },
          },
          tooltip: {
            trigger: 'axis',
            // formatter: (data) => {
            //   let str = `<div>${data[0].name}</div>`
            //   data.forEach((item, i) => {
            //     let value = (item.data[item.seriesIndex + 1] * 100).toFixed(2) + '%'
            //     str += `<div> ${item.seriesName}：${value} </div>`
            //   })
            //   return str
            // }
          },
          series: [
            {
              type: 'line'
            },
            {
              type: 'line'
            },
            {
              type: 'line'
            },
          ],
        },
      }
    }
  }
</script>

<style scoped>
  .card {
    margin: 0 16px 16px 0;
  }
</style>
<style>
  .c-table-gray {
    background: #f8f8f9;
  }

  .ivu-table {
    background: #f8f8f9;
  }

  .c-table-gray td {
    background: #f8f8f9;
  }
  .el-table th, .el-table tr:nth-child(0){
    background: #f8f8f9;
  }
</style>
